import React from "react";
import {
  CloseIcon,
  InfoIcon,
  PromotionalIcon,
  WarningIcon,
} from "../../assets/svg";
import { getValueByKey } from "../../helper/helpers";

import "./styles.scss";

const iconMapper = {
  warning: WarningIcon,
  informational: <InfoIcon />,
  promotional: <PromotionalIcon  />,
};

const Banner = ({
  notificationType,
  displayMessage,
  canDismiss = false,
  onClose,
  link = "",
}) => {
  const icon = getValueByKey(iconMapper, notificationType);

  return (
    <div className={`app-banner type-${notificationType || "default"}`}>
      <div className="banner-title">
        {icon || null}
        <span>
          {displayMessage}
          {!!link && (
            <a
              href={link}
              className="link-to"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          )}
        </span>
      </div>
      {canDismiss && (
        <button
          type="button"
          className="close-btn"
          onClick={onClose}
          aria-label="Dismiss banner"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default Banner;
